import { Component } from 'react';
import multipleBoxingCountdowns from './countdowns/boxing';
import { warmupCountdown, shortWarmupCountdown } from './countdowns/warmup';
import { coreCountdown, shortCoreCountdown } from './countdowns/core';
import GetReady from './components/GetReady';
import FinishedScreen from './components/FinishedScreen';
import WorkoutScreen from './components/WorkoutScreen';
import StartWorkout from './components/StartWorkout';

/*
  Visual states:

  * The name of the phase (exercise or round #)
  * The current task (HTML)
  * The next task (HTML)
  * The time
*/

class App extends Component {
  state = {
    started: false,
    finished: false,
    seconds: null,
    selectedCountdown: '',
    currentActivity: null,
    nextActivity: null,
    secondsUntillNext: null,
    countdownIndex: 0,
    leftHanded: false
  }

  continueCountdown = (state) => this.setState(state)

  endCountdown = () => {
    const nextCountdownIndex = this.state.countdownIndex + 1;

    if (this.selectedWorkout()[nextCountdownIndex]) {
      this.setState({
        countdownIndex: nextCountdownIndex
      });

      this.selectedWorkout()[this.state.countdownIndex].start();
    } else {
      this.setState({
        finished: true
      });
    }
  }

  startWorkout = (type) => {
    this.setState({
      selectedCountdown: type,
      started: true,
    });

    this.selectedWorkout(type)[this.state.countdownIndex].start();
  }

  shortCountdowns = [
    shortWarmupCountdown(this.continueCountdown, this.endCountdown),
    ...multipleBoxingCountdowns(4, this.continueCountdown, this.endCountdown),
    ...shortCoreCountdown(this.continueCountdown, this.endCountdown)
  ].flat(1)

  basicCountdowns = [
    warmupCountdown(this.continueCountdown, this.endCountdown),
    ...multipleBoxingCountdowns(8, this.continueCountdown, this.endCountdown),
    ...coreCountdown(this.continueCountdown, this.endCountdown),
  ].flat(1)

  longCountdowns = [
    warmupCountdown(this.continueCountdown, this.endCountdown),
    ...multipleBoxingCountdowns(12, this.continueCountdown, this.endCountdown),
    ...coreCountdown(this.continueCountdown, this.endCountdown)
  ].flat(1)

  selectedWorkout = (type) => {
    const workoutType = type ? type : this.state.selectedCountdown;

    switch(workoutType) {
      case 'short':
        return this.shortCountdowns;
      case 'long':
        return this.longCountdowns;
      default:
        return this.basicCountdowns;
    }
  }

  changeDominantHand = (hand) => {
    this.setState({
      leftHanded: (hand === 'left')
    });
  }

  isWaiting = () => (this.state.seconds === null || this.state.seconds === 0)

  render() {
    return (
      <div className={`app-wrapper ${this.state.leftHanded ? 'left-handed' : 'right-handed'}`}>
        <h1 className="app-title">
          Boxing Bot
        </h1>

        <div class="app-content">
          {!this.state.started && !this.state.finished &&
            <div className="medium-width">
              <p>
                Are you left or right handed?
              </p>

              <span class="radio-wrapper">
                <label for="righthand">Right Handed</label>
                <input id="righthand" type="radio" name="1" defaultChecked onChange={() => this.changeDominantHand('right')} />
              </span>

              <span class="radio-wrapper">
                <label for="lefthand">Left Handed</label>
                <input id="lefthand" type="radio" name="1" onChange={() => this.changeDominantHand('left')} />
              </span>

              <StartWorkout
                short={() => this.startWorkout('short')}
                basic={() => this.startWorkout('basic')}
                long={() => this.startWorkout('long')}
              />
            </div>
          }

          {this.state.started && this.state.finished &&
            <FinishedScreen />
          }

          {this.state.started && !this.state.finished && this.isWaiting() &&
            <GetReady />
          }

          {this.state.started && !this.state.finished && !this.isWaiting() &&
            <WorkoutScreen
              phase={this.state.phase}
              exercise={this.state.exercise}
              nextExercise={this.state.nextExercise}
              seconds={this.state.seconds}
              secondsUntilNext={this.state.secondsUntilNext}
            />
          }
        </div>
      </div>
    );
  }
}

export default App;
